import { Popover, Tag } from "antd"
import { useNavigate } from "react-router-dom"
import { ReactComponent as DELETE } from "../../../assets/DeleteICON.svg"
import { Navigation } from "../../../api/constants"
import BaseTableRow from "../../../components/layout/BaseTableRow"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"
import { Tour } from "../types"
import TourWeekdayStrip from "./TourWeekdayStrip"

type TourTableRowType = {
    tour: Tour
    deleteTour: (id: string) => void
}

export default function TourTableRow(props: TourTableRowType) {
    const navigate = useNavigate()
    const employeeName = props.tour.employee ? `${props.tour.employee.first_name} ${props.tour.employee.last_name}` : "Nicht zugewiesen"

    return (
        <BaseTableRow onClick={() => navigate(Navigation.TOURS + props.tour._id)}>
            <td className="table-cell">
                <p className="line-clamp-1 text-center font-medium">{props.tour.name}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[10rem]">{employeeName}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">{props.tour.stops.length}</p>
            </td>
            <td className="hidden lg:table-cell">
                <div className="flex justify-center py-1">
                    <TourWeekdayStrip tour={props.tour} compact />
                </div>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">
                    <Tag className="w-24 text-center" color={props.tour.active ? "green" : "default"}>
                        {props.tour.active ? "Aktiv" : "Pausiert"}
                    </Tag>
                </p>
            </td>
            <td onClick={(event) => event.stopPropagation()}>
                <Authorized allOf={[P.termine_management]}>
                    <Popover
                        placement="bottomLeft"
                        title="Löschen?"
                        content={
                            <div className="flex flex-col items-end">
                                <p>Wollen Sie diese Tour wirklich entfernen?</p>
                                <button className="btn btn-sm btn-error mt-2" onClick={() => props.deleteTour(props.tour._id)}>
                                    Löschen
                                </button>
                            </div>
                        }>
                        <DELETE className="w-6 h-6 cursor-pointer hover:text-error mx-auto" />
                    </Popover>
                </Authorized>
            </td>
        </BaseTableRow>
    )
}
